import {signUpTypes} from "../AuthActionsTypes/SignUpActionsTypes";

/**
 * Set Error 400
 * @param error {object} The response error.
 * @returns {{type: {string} The action type, message: object The error message object}}
 */
export const setUserSignUpError400 = error => {
    const {data} = error.response;
    const {message} = data;

    const errorsMessage = message
        .map(message => ({[message.property]: message.errors[0]}))
        .reduce(((result, item) => Object.assign(result, item)), {});

    return {
        type: signUpTypes.SET_ERRORS,
        message: errorsMessage,
    };
};

/**
 * Set general error.
 * @param error {object} The response error.
 * @returns {{name: *, type: *, message: *}}
 */
export const setUserSignUpGeneralError = error => {
    const {data} = error.response;
    const {message} = data;

    return {
        type: signUpTypes.SET_ERROR,
        name: signUpTypes.GENERAL_ERROR,
        message: message,
    };
};


export const setUserSignUpUnknownError = error => {
    return {
        type: signUpTypes.SET_ERROR,
        name: signUpTypes.UNKNOWN_ERROR,
    };
};


export const setUserSignUpError = error => {
    if (!error.response) {
        return setUserSignUpUnknownError(error);
    }

    const {data} = error.response;

    if (data.statusCode === 400)
        return setUserSignUpError400(error);

    return setUserSignUpGeneralError(error);
};


export const removeUserSignUpErrors = error => {
    return {
        type: signUpTypes.REMOVE_ERRORS,
    };
};
